export default __webpack_public_path__ + "static/media/as-melhores-tecnologias.51d95c9d.png";